import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { DevJumbotronComponent } from './dev-jumbotron';

@NgModule({
  entryComponents: [
    DevJumbotronComponent,
  ],
  declarations: [
    DevJumbotronComponent,
  ],
  imports: [
    IonicModule,
  ],
  exports: [
    DevJumbotronComponent
  ]
})
export class DevJumbotronComponentModule { }



// WEBPACK FOOTER //
// ./src/components/dev-jumbotron/dev-jumbotron.module.ts